import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { UserManager } from 'oidc-client'
import NkmDatepicker from 'nkm-datepicker'

import _ from 'lodash'
import { ButtonToolbar } from 'react-bootstrap'
import { CSVLink } from 'react-csv'

import ReactTable from '@norkart/react-table'

import { HentBytter } from '../felles/tablestorageRepository'
import { resolve } from '../dependencies'
import { datoFormatMedTidspunktTekst, datoFormatTall, datoFormatMedBareAar } from '../felles/utils/dato-format-tabell'

import 'react-datetime/css/react-datetime.css'
import 'nkm-datepicker/dist/style.css'

moment.locale('nb')

const columns = [
    {
        id: 'Registrert',
        name: 'Registrert',
        // Sorter på samme felt som vises (Timestamp). Tidligere sorterte kolonnen på
        // 'Registrert' mens den viste 'Timestamp'; i Azure Table Storage oppdateres Timestamp
        // ved hver endring (f.eks. når status settes til Skiftet) mens Registrert settes ved
        // innlegging, så skiftede jobber havnet i feil rekkefølge i rapporten.
        // (Alternativ hvis "registreringstid" er ønsket: vis bytte.Registrert og behold sortParams 'Registrert'.)
        sortParams: 'Timestamp',
        sortable: true,
        filterable: true,
        isSorted: false,
        formatter: function (bytte) {
            return datoFormatMedTidspunktTekst(bytte.Timestamp)
        }
    },
    {
        id: 'Adresse',
        name: 'Adresse',
        sortParams: ['Adresse'],
        sortable: true,
        isSorted: false        
    },
    {
        id: 'Status',
        name: 'Status',
        sortParams: 'Status',
        sortable: true,
        filterable: true,
        isSorted: false,
        formatter: function (bytte) {
            return bytte.Status === 'IkkeSkiftet' ? 'Ikke skiftet' : bytte.Status
        }
    },
    {
        id: 'Brukernavn',
        name: 'Navn',
        sortParams: 'Brukernavn',
        sortable: true,
        filterable: true,
        isSorted: false
    },

    {
        id: 'IkkeSkiftetMelding',
        name: 'Melding',
        sortParams: 'IkkeSkiftetMelding',
        sortable: true,
        filterable: true,
        isSorted: false
    },
    {
        id: 'BildeUrler',
        name: 'Bilder',
        isSorted: false,
        formatter: function (bytte) {
            if (!_.isEmpty(bytte.BildeUrler)) {
                var urler = _.split(bytte.BildeUrler, ',')

                var bildeLenker = urler.map((url, i) => {

                    return <a key={i} href={url} target="_blank" style={{ marginRight: '3px' }}>{i + 1}</a>
                })
                return bildeLenker
            }
        }
    }
]

const bytterFordeltPaaDagerKolonner = [
    {
        id: 'dato',
        name: 'Dato',
        sortParams: 'dato',
        sortable: true,
        filterable: true,
        isSorted: false,
        formatter: function (bytte) {
            return datoFormatTall(bytte.dato)
        }
    },
    {
        id: 'antallSkiftet',
        name: 'Skiftet',
        sortParams: 'antallSkiftet',
        sortable: true,
        filterable: true,
        isSorted: false
    },
    {
        id: 'antallIkkeSkiftet',
        name: 'Ikke skiftet',
        sortParams: 'antallIkkeSkiftet',
        sortable: true,
        filterable: true,
        isSorted: false
    },
    {
        id: 'times',
        name: 'Totalt',
        sortParams: 'times',
        sortable: true,
        filterable: true,
        isSorted: false
    }
]

const bytterFordeltPaaAarKolonner = [
    {
        id: 'dato',
        name: 'Dato',
        sortParams: 'dato',
        sortable: true,
        filterable: true,
        isSorted: false,
        formatter: function (bytte) {
            return datoFormatMedBareAar(bytte.dato)
        }
    },
    {
        id: 'antallSkiftet',
        name: 'Skiftet',
        sortParams: 'antallSkiftet',
        sortable: true,
        filterable: true,
        isSorted: false
    },
    {
        id: 'antallIkkeSkiftet',
        name: 'Ikke skiftet',
        sortParams: 'antallIkkeSkiftet',
        sortable: true,
        filterable: true,
        isSorted: false
    },
    {
        id: 'times',
        name: 'Totalt',
        sortParams: 'times',
        sortable: true,
        filterable: true,
        isSorted: false
    }
]


const headers = [{ label: "Registrert", key: 'Registrert' }, { label: "Adresse", key: 'Adresse' }, { label: "Status", key: 'Status' }, { label: "Bruker", key: 'Brukernavn' }, { label: "Melding", key: 'IkkeSkiftetMelding' }]

export default class Rapporter extends Component {
    constructor() {
        super()
        this.test = this.test.bind(this)
    }

    state = {
        bytter: [],
        bytterFordeltPaaDager: [],
        bytterCsv: [],
        bytterCsvFilinnhold: [],
        bytterFordeltPaaMnd: [],
        sokeStreng: '',
        sokeDato: moment()
    }


    componentDidMount() {           
        HentBytter(this.test, null)
    }

    formaterDatoForBytte(bytte) {
        bytte.Registrert = datoFormatTall(bytte.Registrert)
        return bytte;
    }

    formaterAdresseForBytte(bytte) {
        bytte.Adresse =  bytte.Adresse +' ' + bytte.Husnummer + ' ' +   (bytte.Husbokstav ? bytte.Husbokstav : '')
        return bytte;
    }

    test(res) {
        // Initiell sortering må bruke samme felt som kolonnen viser/sorterer på (Timestamp),
        // ellers vises rapporten først sortert på Registrert (innleggingstid) og «hopper» til
        // Timestamp-rekkefølge ved første klikk på kolonnehodet. Timestamp oppdateres når en
        // jobb endres (f.eks. settes til Skiftet), så skiftede jobber kommer nå i riktig
        // rekkefølge også i standardvisningen. (Dag/år-grupperingene under bruker bevisst
        // Registrert og er upåvirket.)
        res = _.orderBy(res, ['Timestamp'], ['desc'])

        var occurrenceDay = function (occurrence) {
            return moment(occurrence.Registrert)
                .startOf('day')
                .format()
        }

        var occurrenceMonth = function (occurrence) {
            return moment(occurrence.Registrert)
                .startOf('year')
                .format()
        }

        var groupToDay = function (group, day) {
            var ikkeSkiftet = _.filter(group, function (g) {
                return g.Status === 'IkkeSkiftet'
            })

            var skiftet = _.filter(group, function (g) {
                return g.Status === 'Skiftet'
            })

            return {
                dato: day,
                times: group.length,
                antallSkiftet: _.size(skiftet),
                antallIkkeSkiftet: _.size(ikkeSkiftet)
            }
        }

        var resultGroupByDay = _.chain(res)
            .groupBy(occurrenceDay)
            .map(groupToDay)
            .orderBy('dato', ['desc'])
            .value()
            
        
        var resultGroupByMonth = _.chain(res)
            .groupBy(occurrenceMonth)
            .map(groupToDay)
            .orderBy('dato', ['desc'])
            .value()

        var bytter = res;
        var bytterCsv = _.map(res, this.formaterDatoForBytte)
        bytterCsv = _.map(bytterCsv, this.formaterAdresseForBytte)

        this.setState({
            bytter,
            bytterFordeltPaaDager: resultGroupByDay,
            bytterFordeltPaaMnd: resultGroupByMonth,
            bytterCsv
        })
    }

    filterChanged(property, value) {

        if (!value) {
            value = ''
            this.setState({
                sokeStreng: value,
                sokeDato: moment(),
                bytter: this.state.bytterCsv
            })
        } else {
            if (property === 'adresse') {

                value = value.toLowerCase()
                
                var sokeRes = _.filter(
                    this.state.bytterCsv,
                    m =>
                        m.Adresse.toLowerCase().includes(value)
                )

                this.setState({
                    sokeStreng: value,
                    bytter: sokeRes
                })
            }

            if (property === 'registrert') {                                
                var sokeDatoStreng = datoFormatTall(value)                
                var sokeResDato = _.filter(
                    this.state.bytterCsv,
                    m =>
                        datoFormatTall(m.Timestamp) === sokeDatoStreng
                )
                
                this.setState({
                    bytter: sokeResDato,
                    sokeDato: value
                })
            }
        }
    }

    render() {
        return (
            <div className="listeContainer">
                <h2>Rapporter </h2>

                <h3>Alle bytter</h3>

                <ButtonToolbar>
                    <CSVLink
                        data={this.state.bytter}
                        headers={headers}
                        filename="bytter.csv"
                        className="btn btn-primary"
                    >
                        Last ned
                    </CSVLink>                
                </ButtonToolbar>
                
                <Link  to='/hjelp#rapportfil'>Hjelp til import av rapportfil i Excel</Link>
                <br />

                <div className="form-group">
                    <div style={{ width: 30 + '%' }}>
                        <input
                            className="form-control"
                            placeholder="Søk etter adresse"
                            type="text"
                            value={this.state.sokeStreng}
                            onChange={e => this.filterChanged('adresse', e.target.value)}
                        />
                    </div>

                    <div style={{ width: 40 + '%' }}>
                        <NkmDatepicker
                            dateFormat="DD.MM.YYYY"                                                                
                            value={this.state.sokeDato} 
                            onChange={(e) => this.filterChanged('registrert', e)}
                            closeOnSelect={true} />
                    </div>
                </div>

                <ReactTable
                    items={this.state.bytter}
                    idProperty="RowKey"
                    showIndex={false}
                    filterable={false}
                    itemsPrPage={10}
                    columns={columns}
                    selectableRows={false}
                />
                <h3>Utførte bytter fordelt på dag</h3>
                <ReactTable
                    items={this.state.bytterFordeltPaaDager}
                    idProperty="dato"
                    showIndex={false}
                    filterable={false}
                    itemsPrPage={10}
                    columns={bytterFordeltPaaDagerKolonner}
                    selectableRows={false}
                />

                <h3>Utførte bytter fordelt på år</h3>
                <ReactTable
                    items={this.state.bytterFordeltPaaMnd}
                    idProperty="dato"
                    showIndex={false}
                    filterable={false}
                    itemsPrPage={10}
                    columns={bytterFordeltPaaAarKolonner}
                    selectableRows={false}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/rapporter/rapporter.jsx